/**
 * Import
 * - Libraries
 */
import * as React from 'react'
import { Redirect } from 'react-router'

/**
 * Logout class for rendering the result
 *  It will execute the action of Logout and redirect to Login
 */
export default class Logout extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
    }

    componentWillMount() {
        this.props.logout()
    }

    render() {
        return (
            <Redirect
                to={{
                    pathname: '/login',
                }}
            />
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Logout/Logout.tsx